import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_ERROR_LOG_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ERROR_LOG_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_ERROR_LOG_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ERROR_LOG_SUCCESS`;
export const INTELLIGENT_PHOTO_CAPTURE_ERROR_LOG_FAILURE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ERROR_LOG_FAILURE`;
export const photoCaptureIntelligentErrorLogRequestAction = (companyCode, request, instanceReferenceId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ERROR_LOG_REQUEST,
    payload: { companyCode, request, instanceReferenceId }
});
export const photoCaptureIntelligentErrorLogSuccessAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ERROR_LOG_SUCCESS,
    payload: {}
});
export const photoCaptureIntelligentErrorLogFailureAction = failureMessage => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ERROR_LOG_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=photoCaptureIntelligentErrorLogAction.js.map